export default {
  meta: {
    title1: "Activate",
    title2: "Login Page",
    title3: "Register Page",
    title4: "Retrieve Password",
    title5: "Message List",
    title6: "Product Details",
    title7: "Shop Details",
    title8: "Search page",
    title9: "Registered Shop",
    title10: "Product List",
    title11: "Selected Products",
    title12: "Supplier Manage",
    title13: "Product Display Page",
    title14: "Product Details Page",
    title15: "Product Edit Page",
    title16: "Contact Suppliers",
    title17: "Administrator Login",
    title18: "User Center",
    title19: "My Order",
    title20: "User Settings",
    title21: "My Collection",
    title22: "Shop Attention",
    title23: "View History",
    title24: "Delivery Address",
    title25: "Offline Payment",
    title26: "Order Page",
    title27: "Delivery address Details",
    title28: "Product Page",
    title29: "Product Classification",
    title30: "Import Product",
    title31: "Order Detail",
    title32: "Commodity Analysis",
    title33: "Financial Statement",
    title34: "Certification Data",
    title35: "Add Document",
    title36: "Edit Phone Number",
    title37: "Contact Customer Service",
    title38: "Service Details",
    title39: "Investment Rules",
    title40: "Individual User Service Agreement",
    title41: "Privacy Policy",
    title42: "Shipping and Delivery",
    title43: "About Us",
    title44: "Problem Feedback",
  },
  B2C: {
    back: "Back",
    noMessage: "No message",
    noData: "No data",
    more: "More products are coming soon.",
    download: "Vancheen App",
    ios: "ios",
    android: "android",
    hotSales: "Hot product",
    registerShop: "Register shop",
    shopState1: "Authenticated",
    shopState2: "Authentication failed",
    shopState3: "Unauthentication",
    shopState4: "Authenticating",
    supplierAuth: "Supplier authentication",
    login: "Login",
    message: "Messages",
    buy: "Buy now",
    addCart: "Add to cart",
    shopCart: "Shopping cart",
    productsOff: "These product are unavailable",
    inventoryState1: "Under stock",
    inventoryState2: "Out of stock",
    productOff: "This product is unavailable",
    offShelf: "This product has been removed from sale",
    follow1: "Followed",
    follow2: "Follow",
    success: "Success",
    skuError: "Not found in the commodity sku price collection",
    priceError: "Products do not have a product price set",
    enterShop: "Enter the shop",
    productInfo: "Product information",
    weight: "Weight",
    volume: "Volume",
    desc: "Product description",
    qty: "Purchase quantity",
    inventory: "Inventory",
    inventoryText: "This product is out of stock",
    inventoryLimit: "Quantity is over the inventory",
    inputContent: "Please input content",
    orderInfo: "Order information",
    receiveAddress: "Delivery address",
    name: "Name",
    phone: "Phone number",
    postalCode: "Postcode",
    address: "Address",
    noAddress: "No address available",
    addAddress: "Create address",
    mode: "Distribution mode",
    addressError: "The country that has selected 'delivery address' has no delivery method, please change the address",
    selectAddress: "Please select the delivery address first",
    fWeight: "First weight",
    cWeight: "Continue weight",
    freightTotal: "Total freight",
    confirmOrder: "Confirm order information",
    productPhoto: "Product photo",
    productName: "Product name",
    productPrice: "Price",
    number: "Quantity",
    model: "Specification",
    shopName: "Shop name",
    package: "Total {number} piece",
    total: "Total",
    submit: "Submit",
    addressVaild1: "Please select delivery address",
    addressVaild2: "Please select delivery method",
    select: "Please select",
    input: "Please input",
    editProduct: "Edit product",
    addProduct: "Create product",
    productClass: "Product class",
    productName: "Product name",
    productModel: "Product model",
    productFeatures: "Product features",
    productDesc: "Product description",
    customize: "Customizable",
    yes: "Yes",
    no: "No",
    isShowcase: "is it set as a window product",
    productState: "Product status",
    pState1: "Publish",
    pState2: "Off shelf",
    productionTime: "Production time (days)",
    fileList: "File list",
    uploadText: "No more than 640px x 640px images must be uploaded, at least 3 images",
    uploadRuleText1: "Please upload photos",
    uploadRuleText2: "Upload a minimum of 3 and a maximum of 5 photos",
    uploadSuccess: "upload success",
    submitSuccess: "Submit success",
    vButton: "go to verify",
    newProduct: "New products",
    recommend: "Recommend products",
    loading: "Loading",
    productTotal: "Product total",
    discount: "Discount",
    brand: "Brand",
    attestation: "Attestation",
    discountProducts: "Discount products",
    brandProducts: "Brand products",
    attestationProducts: "Attestation products",
  },
  B2B: {
    header1: "E-commerce platforms",
    header2: "Login administrator",
    header3: "Logout administrator",
    header4: "Login supplier",
    header5: "Supplier manage",
    header6: "User center",
    header7: "User login",
    header8: "B2B Wholesale",
    header9: "Homepage",
    header10: "New homepage",
    header11: "B2C Retail Store",
    navbar1: "Activities",
    navbar2: "Procurement",
    navbar3: "Consult",
    navbar4: "About",
    navbar5: "Search",
    title1: "The Middle East Holidays And Business Events",
    title2: "Industrial Library",
    subTitle1: "Upcoming events",
    classTitle1: "Building materials",
    classTitle2: "Dress collocation",
    classTitle3: "Food and drink",
    classTitle4: "Production equipment",
    classTitle5: "Household appliance",
    classTitle6: "Car accessories",
    hidden: "Hidden",
    display: "Display",
    edit: "Edit",
    delete: "Delete",
    cancelEdit: "Cancel edit",
    createSlides: "Create slides",
    editSlides: "Edit slides",
    editIcon: "Edit Icons",
    createClass: "Create category",
    editClass: "Edit category",
    classIcon: "Category icon",
    createAd: "Create advertisement",
    editAd: "Edit advertisement",
    title: "Chinese Title",
    titleEn: "English title",
    input: "Please input",
    desc: "Chinese Description",
    descEn: "English description",
    poster: "Event poster",
    link: "Jump link",
    sort: "Sort",
    notice: "Platform prompt",
    contentAd: "Are you sure to delete this AD?",
    cancel: "Cancel",
    submit: "Confirm",
    uploadImage: "Please upload photo",
    imageLimit: "Only 1 picture can be upload",
    success: "Success",
    back: "Back",
    toBasket: "Add to basket",
    inquiry: "Inquiry",
    keyword: "Product keyword",
    select: "Please select",
    search: "Search",
    reset: "Reset",
    noData: "No data",
    orderBy1: "Latest publish date",
    orderBy2: "Product views",
    repeat: "The commodity is exist",
    addSuccess: "Add success",
    vButton: "go to verify",
  },
  collapse1: {
    title: "Meetings and exhibitions"
  },
  collapse2: {
    title: "Q&A",
    noData: "No content",
    tab1:
      "Extensive product selection: Discover high quality products from all walks of life around the world to meet your purchasing needs.",
    tab2:
      "Direct supply chain links: Direct dialogue with manufacturers and suppliers to reduce intermediate links and optimize procurement costs.",
    tab3:
      "Customized solutions: Whether you are ordering in bulk or looking for specific specifications, we can provide a personalized service to meet your business needs.",
    tab4:
      "Secure Transaction protection: Our secure payment systems and transaction protection policies ensure a hassle-free purchasing process.",
    tab5:
      "Comprehensive customer support: A dedicated customer service team is always ready to help you with any issues you may encounter during the trading process.",
    tab1Title1: "1. How do I register a vancheen account?",
    tab1Content1: {
      t1: "If you will not be using the vancheen platform. click here",
      t2: "Vancheen Platform operation process",
      t3:
        " .after clicking, you will be able to see how to play the vancheen platform to help you better understand the operation of the platform!"
    },
    tab1Title2: "2. How to search for desired products quickly?",
    tab1Content2: {
      t1:
        "a. Use the name of the product or the corresponding manufacturer, such as: if you want to find 'flour', you can use 'flour' search, you can also use 'flour factory' to search in the manufacturer channel.",
      t2:
        "b. Using filters, we provide a variety of filters, such as: 'brand', 'price', 'city' and so on. Using filters can help you further improve the accuracy of your search"
    },
    tab1Title3: "3. How to pay after choosing the desired product?",
    tab1Content3: {
      t1:
        "You can use credit cards, online banking, wechat payment, Alipay payment, corporate reconciliation."
    },
    tab1Title4: "4. How to give feedback when encountering problems?",
    tab1Content4: {
      t1:
        "I am very sorry to make you have a bad experience, you can feedback your problems in the following ways:",
      t2: "a.Click here",
      t3: "Feedback form",
      t4:
        " .after entering, you can fill out the form to submit feedback questions",
      t5: "send an email detailing the problem you encountered.",
      t6:
        "thank you for your feedback. We will solve the problem as soon as possible after receiving your feedback."
    }
  },
  collapse3: {
    title1: "Vancheen introduce",
    title2: "Platform purpose",
    title3: "Platform concept",
    content1:
      "Discover supply and demand, trade easily! Our vancheen platform has a wealth of customer resources to help you quickly find the suppliers you need. We provide a convenient online payment system to ensure safe and fast transactions. Efficient trading processes allow you to save time and cost and complete transactions easily. Whether you're buying or selling, we can help you expand your global market and build relationships with quality suppliers. With our platform, you can realize global business opportunities and accelerate business growth. Join our vancheen platform today to start more efficient and convenient business transactions!",
    content2:
      "Simplify business processes, reduce transaction costs, improve transaction efficiency, and facilitate business growth between partners.",
    content3:
      "We understand that every transaction is not only a transfer of products, but also a building of business value and trust. Join us to expand your business boundaries and allow your business to thrive in the global marketplace."
  },
  basket: {
    title: "Inquiry basket",
    product: "Product",
    supplier: "Supplier",
    submit: "Submit",
    clear: "Clear",
    noData: "No data"
  },
  navBar: {
    search: "Search"
  },
  topProduct: {
    subTitle: "Selected goods",
    empty: "More products are coming soon!",
    all: "All"
  },
  commodity: {
    model: "Product model",
    customize: "Customizable",
    yes: "Yes",
    no: "No",
    feature: "Feature",
    removeShowcase: "Remove window products",
    setShowcase: "Set as a window item",
    desc: "Description",
    contact: "Contact supplier",
    lastUpdate: "Supplier information last updated",
    profile: "Supplier profile",
    expand: "Unfold",
    collapse: "Fold",
  },
  business: {
    lastUpdate: "Supplier information last updated",
    profile: "Supplier profile",
    expand: "Unfold",
    collapse: "Fold",
    createCommodity: "Create goods",
    searchInside: "Search in this store",
    sort: "Sort",
    selection: "Selection",
    state: "State",
    tab1: "Home page",
    tab2: "Product / Service",
    orderBy1: "Latest publish date",
    orderBy2: "Product views",
    state1: "Publish",
    state2: "Off shelf",
    yes: "Yes",
    no: "No",
    delete: "Delete success",

    choiceness: "Selected products/services",
    viewAll: "View all",
    showcase: "Showcase",
    edit: "Edit",
    delete: "Delete",
    noProduct: "No product",
  },
  enquiry: {
    contact: "Contact supplier",
    notice: "The following information will be sent to the supplier",
    email: "Email address (input in your company email address to get a quick response from your supplier)",
    tail: "We will set up an account for you to contact the supplier, please check the email and activate the account.",
    step1: "Step 1",
    step2: "Step 2",
    addressee: "Addressee",
    qty: "Purchase quantity",
    tradeCountry: "Destination country",
    currency: "Settlement currency",
    customize: "Customize",
    nature: "Business nature",
    emailAddress: "Email address",
    appellation: "Appellation",
    name: "Name",
    surname: "Surname",
    companyName: "Company name",
    country: "Country / Region",
    province: "State / Province",
    city: "City",
    content: "Query content",
    tags: "Here are some common questions from other buyers. Click to add them to your inquiry message.",
    submit: "Submit",
    aOption1: "Doctor",
    aOption2: "Miss",
    aOption3: "Sir",
    aOption4: "Mrs",
    aOption5: "Madam",
    aOption6: "Professor",
    yes: "Yes",
    no: "No",
    success: "Success"
  },
  feedback: {
    title: "Problem feedback",
    name: "Name",
    phone: "Phone number",
    email: "Email",
    content: "Feedback content",
    suggestion: "Improvement suggestion",
    file: "Attachment upload",
    limit: "Only 3 attachments can be upload",
    submit: "Submit",
    thanks: "Thank you for your feedback"
  },
  login: {
    userLogin: "C-User login",
    supplierLogin: "Login supplier",
    inputEmail: "Please input email",
    inputPhone: "Please input phone number",
    inputCorrect: "Please input the correct mobile number",
    inputPassword: "Please input password",
    forgetPassword: "Forget password?",
    login: "Login",
    register: "Register",
    registerText: "I don't have an account. I'm going to",
    loginSuccess: "Login success",
    userRegister: "User register",
    supplierRegister: "Supplier register",
    email: "Email",
    vCode: "Verifiy code",
    inputCode: "Please input the verification code",
    password: "Password",
    invCode: "Invitation code",
    optional: "Optional",
    phoneNumber: "Phone number",
    confirmPassword: "Confirm password",
    text1: "Click to agree",
    text2: "《Vancheen Individual User Service Agreement》",
    and: "And",
    text3: "《Vancheen Privacy Policy》",
    text4: "《Vancheen Terms of service》",
    text5: "I have finished registering and I want to",
    inputCorrectEmail: "Please input the correct email address",
    inputCorrectPhone: "Please input the correct mobile number",
    passwordRule1: "The password must be at least 8 digits long",
    passwordRule2: "For the sake of your information security please do not be too simple password",
    passwordRule3: "For the security of your information, please set the password to a combination of uppercase and lowercase letters + numbers",
    passwordRule4: "The two passwords are inconsistent",
    passwordRule5: "Please input your confirmation password",
    passwordRule6: "Please input your password again",
    sendCode: "Send message",
    registerSuccess: "Congratulations, registration is successful",
    retrievePassword: "Retrieve the password",
    retrieve1: "C-User retrieve password",
    retrieve2: "Supplier retrieve password",
    step1: "Retrieval mode",
    step2: "Verify identity",
    step3: "Set a new password",
    step4: "Finish",
    cEmail: "Verify email",
    cPhone: "Verify phone number",
    inputNewPassword: "Please input a new password",
    backLogin: "Back to login",
    confirm: "Confirm",
    nextStep: "Next step",
    adminLogin: "Admin login",
    inputUsername: "Please input username"
  },
  container: {
    notice: "List of announcements",
    top: "Pinned",
    noticeText: "There are {number} bulletins in total",
    previous: "Previous page",
    next: "Next page",
    noNotice: "No announcement",
    noticeDetail: "Announcement details",
    switch1: "Switch the B2B business profile page",
    switch2: "Switch B2B2C to publish goods",
    backHome: "Home page",
    settings: "User settings",
    logout: "Log out",
    serviceEmail: "Customer service email",
    contactService: "Contact customer service",
    serviceText: "Select the service you need",
    select: "Please select",
    inputContent: "Plesea input",
    contactWay: "Your contact information",
    inputEmail: "Please provide your email address",
    submit: "Submit",
    bandTitle: "Platform prompt",
    bandContent: "Your account has been blocked in violation, please contact vancheen customer service",
    close: "Close",
    sOption1: "Complaints and suggestions",
    sOption2: "Refund application",
    sOption3: "Others",
    rOption1: "Authentication not pass",
    rOption2: "Authenticating",
    rOption3: "Unauthentication",
    rOption4: "Please upload authentication information",
    rOption5: "Authentication fail",
    infoError: "Your information is still authenticating",
    submitError: "Please input all before submit",
    tips: "Tips"
  },
  public: {
    upload: "Upload Company Logo",
    display1: "Enterprise name English display",
    display2: "Enterprise name picture display",
    input: "Please input",
    select: "Please select",
    companyNameCn: "Company Name (Chinese)",
    companyNameEn: "Company name (English)",
    characterColorCode: "Enterprise name word color",
    backgroundColorCode: "Business name background color",
    companyNameImage: "Picture display",
    companyProfileCn: "Company Introduction in Chinese",
    companyProfileEn: "Company Introduction in English",
    classValue: "Store display category",
    orderBy: "Sort",
    submit: "Submit",
    product: "Product",
    productShow: "Product display",
    editPage: "Enter edit page",
    others: "Others",
    feedback: "Problem feedback",
    toFeedback: "Go to feedback",
    explain: "Explain",
    state1: "The certification materials you submitted were not approved",
    state2: "Recertification",
    orderBy1: "Latest release date",
    orderBy2: "Product page views",
    orderBy3: "Product number of sales",
    rule1: "Please use the company Logo",
    rule2: "Please input company name (Chinese)",
    rule3: "Please input company name (English)",
    infoAlert: "Please complete the enterprise information first",
    alert: "Information is still authenticating",
    uploadSuccess: "Upload success",
    tips: "Tips",
    saveSuccess: "Save success",
  },
  default: {
    title1: "Unpay",
    title2: "Undeliver",
    title3: "Logistics anomaly",
    title4: "Violation reminder",
    title5: "Conceptual data",
    title6: "Number of visitors",
    title7: "Number of buyers",
    title8: "Payment amount",
    compare: "Earlier",
    person: "Person",
    dollar: "Dollar",
    subTitle1: "Product management",
    menu1: "Public product",
    menu2: "Goods in sale",
    menu3: "Goods in warehouse",
    subTitle2: "Logistics management",
    menu4: "Unpay",
    menu5: "Undelivery",
    menu6: "Delivered",
    subTitle3: "Data center",
    menu7: "Aggregate data",
    menu8: "Commodity analysis",
    subTitle4: "Finance center",
    menu9: "Financial statement"
  },
  order: {
    tab1: "All",
    tab2: "Wait for pay",
    tab3: "Wait for delivery",
    tab4: "Delivered",
    tab5: "Succeed order",
    tab6: "Closed order",
    batch: "Batch update the tracking number",
    totalOrder: "{number} orders in total",
    previous: "Previous page",
    next: "Next page",
    col1: "Product",
    col2: "Unit price",
    col3: "Quantity",
    col4: "Operate",
    col5: "Trading status",
    col6: "Received funds",
    orderNumber: "Order number",
    createTime: "Create time",
    allPrice: "Total amount",
    specification: "Specification",
    inputExpress: "Input tracking number",
    inputExpressNumber: "Please input tracking number",
    expresNumber: "Tracking number",
    noToPay: "Not accept cash on delivery",
    closeOrder: "Close order",
    detail: "Detail",
    viewLogistics: "View logistics",
    printTag: "Print label",
    noData: "No data",
    cancel: "Cancel",
    confirm: "Confirm",
    tips: "Tips",
    reason: "Please select the reason for closing the order"
  },
  analysis: {
    title: "TOP50 visitors",
    tab1: "Nearly three days",
    tab2: "Nearly seven days",
    tab3: "Last 30 days",
    tab4: "All",
    col1: "Product",
    col2: "Publish time",
    col3: "Page view",
    col4: "Number of visitors",
    col5: "Payment amount",
    col6: "Number of paid buyers",
    col7: "Payment conversion rate",
    col8: "Selected number"
  },
  finance: {
    balance: "Total account amount (USD)",
    rate: "Today's exchange rate",
    time: "Date",
    filter: "Filter",
    select: "Please select",
    search: "Search",
    startDate: "Start date",
    to: "To",
    endDate: "End data",
    text1: "The total amount of revenue and expenditure settled during the period",
    income: "Income",
    payout: "Payout",
    text2: "Settlement of income and expenditure details during the period",
    text3: "Settlement of income and expenditure details",
    text4: "Settlement of total income and expenditure",
    text5: "Please complete your ID number first",
    text6: "Apply success, please contact customer service",
    excel: "Export excel table",
    entryTime: "Entry date",
    flow: "Fund number",
    financialType: "Financial type",
    moneyAmount: "Amount received",
    oneWeek: "Last week",
    oneMonth: "Last month",
    threeMonth: "Last three months",
    withdraw: "Withdraw",
    all: "All",
    tips: "Tips",
    dialogSubTitle: "Total amount withdraw",
    dText1: "Please select a withdraw account",
    account1: "Business account",
    account2: "Legal person/personal account",
    account3: "Complete the identity card number",
    dText2: "Please select the order you want to withdraw",
    col1: "Order number",
    col2: "Amount",
    col3: "Time",
    cancel: "Cancel",
    confirm: "Confirm",
    withdrawRecord: "Withdraw record",
    incomeText: "{startTime} to {endTime} income and payout detail",
    success: "Success",
    successText: "Export success",
    fail: "Error",
    failText: "Export fail",
    message: "message",
    messageText: "There is no exportable data"
  },
  products: {
    tab1: "Product for sale",
    tab2: "Product in warehouse",
    btn1: "Set on sale",
    btn2: "Set off sale",
    btn3: "Batch delete",
    btn4: "Create product",
    count: "{number} total product",
    col1: "Product name",
    col2: "Price",
    col3: "Sales",
    col4: "Create time",
    onSale: "On sale",
    warehouse: "In warehouse",
    col5: "Remark",
    col6: "Operate",
    col7: "Total inventory",
    inventoryState1: "Under stock",
    inventoryState2: "Out of stock",
    now: "",
    state1: "Set on sale",
    state2: "Off shelf",
    edit: "Edit product",
    delete: "Delete",
    deleteText: "Please select the product you want to delete",
    deleteSuccess: "Delete success",
    tips: "Tips",
    selectText: "Please select the product that needs {string}",
    success: " Success",
    confirm: "Confirm",
    isCouponProduct: "Discount",
    isBrandProduct: "Brand",
    isAttestationProduct: "Attestation",
    yes: "Yes",
    no: "No",
  },
  productClasses: {
    breadcrumb1: "Product management",
    breadcrumb2: "Publish product",
    history: "History",
    selectText: "Your current choice is",
    submit: "Submit",
    tips: "Tips",
    text1: "Only when the goods are traded on the Vancheen Platform, Vancheen will pay 10% of the transaction amount of the goods as the platform royalty.",
    text2: "For example, if the goods you publish are sold for $100 on the Vancheen platform, the platform will charge a platform usage fee of 100×10%= $10. The amount to be settled by the merchant is $90. This fee includes the handling fee of the overseas third-party collection platform.",
    text3: "If the charging rules change, Vancheen will update the platform in a timely manner. Merchant withdrawal please refer to merchant withdrawal Rules and conditions.",
    confirm: "Confirm",
    unselect: "Unselect",
    selectClass: "Please select category",
  },
  productEdit: {
    breadcrumb1: "Product management",
    breadcrumb2: "Publish product",
    breadcrumb3: "Basic information",
    breadcrumbTips: "Warm suggestion: Please input in English as preferred",
    unselect: "Unselect",
    editCategory: "Edit category",
    productName: "Product name",
    productPlaceHolder: "Please enter product name (must be in English)",
    productNote: "The Product name is 64 characters limit",
    keyword: "Keyword",
    createKeyword: "Create keyword",
    keywordNote: "Search for products to match the product name and keywords, each product set a maximum of 10 keywords.",
    weight: "Weight",
    weightPlaceholder: "Weight with package",
    kilogram: "Kilogram",
    kilogramNote: "4 decimal Limit",
    volume: "Volume",
    long: "Long",
    width: "Width",
    height: "Height",
    packageVolume: "Package volume",
    precision: "3 decimal Limit",
    descriptions: "Product description",
    descriptionsNote: "Please input product description (must be in English)",
    uploadPhoto: "Upload pictures",
    uploadPhotoNote: "No more than 640px x 640px images must be uploaded, at least 3 images",
    uploadVideo: "Upload video",
    uploadVideoNote: "The maximum video upload limit is 10MB",
    nature: "Product nature",
    attribute: "Product attribute",
    liquid: "Liquid",
    powder: "Powder",
    paste: "Paste",
    charged: "Charged ( Battery include )",
    magnetic: "Magnetic",
    dontBelong: "Don't belong above",
    specTitle: "Inventory/Specifications",
    spec: "Product specification",
    inputSpec: "Please select or input specifications",
    specSettings: "Specification setting",
    oPrice: "Original price",
    cPrice: "Current price",
    inventory: "Inventory",
    selectAll: "Select all",
    cancel: "Cancel",
    setPrice: "Batch setting price",
    setInventory: "Batch setting inventory",
    onShelfSettings: "Public setting",
    deposit: "Put in warehouse",
    onShelf: "Ready for sale ( Can be delivery in 24 hours )",
    remark: "Remark",
    inputRemark: "Please input remark",
    submit: "Submit",
    productCategory: "Product category",
    explain: "Explain",
    tips: "Tips",
    text1: "Only when the goods are traded on the Vancheen Platform, Vancheen will pay 10% of the transaction amount of the goods as the platform royalty.",
    text2: "For example, if the goods you publish are sold for $100 on the Vancheen platform, the platform will charge a platform usage fee of 100×10%= $10. The amount to be settled by the merchant is $90. This fee includes the handling fee of the overseas third-party collection platform.",
    text3: "If the charging rules change, Vancheen will update the platform in a timely manner. Merchant withdrawal please refer to merchant withdrawal Rules and conditions.",
    confirm: "Confirm",
    rule1: "Product description Please input in English",
    rule2: "Please select a category first",
    rule3: "Please input the product name",
    rule4: "The maximum characters of product name is 64",
    rule5: "The maximum characters of subhead is 64",
    rule6: "The maximum of 10 keywords per item can be set",
    rule7: "Please input basic sales",
    rule8: "Please input the correct base sales",
    rule9: "Please input the weight",
    rule10: "Please input the corrent weight",
    rule11: "Please input the volume",
    rule12: "Please input the corrent volume",
    rule13: "Please upload pictures",
    rule14: "Upload a minimum of 3 and a maximum of 10 pictures",
    rule15: "Product specifications The original price can be entered up to two decimal places",
    rule16: "The original price of each product specification should be greater than or equal to 0.1",
    rule17: "Please input the original price for each item specification",
    rule18: "Item specifications Current price Enter a maximum of two decimal places",
    rule19: "The current price of each commodity specification shall be greater than or equal to 0.1",
    rule20: "Please input the current prices for each specification",
    rule21: "Upload a minimum of 1 and a maximum of 18 pictures",
    addText: "${firstPrict} in {firstCount}, add ${addPrice} for each {addCount} item",
    error1: "Existing keyword",
    error2: "Existing",
    error3: "Please select the specification type and input the specification",
    error4: "The content too long (content character length require is 1-40 characters)",
    addFreightTitle: "Create freight template",
    editFreightTitle: "Edit freight template",
    messageSpec: "Please select the specifications you want to set",
    promptPrice: "Please input the price (USD)",
    promptInventory: "Please input the inventory",
    formatPrice: "The price format is incorrect",
    formatInventory: "The inventory format is incorrect",
    submitSuccess: "Submit success",
    couponTitle: "Discount activities",
    couponText: "join in the discount activities",
    brandTitle: "Brand product",
    brandText: "is it brand product",
    brandLogo: "Brand logo",
    brandAuth: "Brand Licensing",
    trademark: "Trademark registration certificate",
    attTitle: "Commodity authentication",
    attText: "is it commodity authentication",
    attType: "Please select authentication type",
    upload: "Please upload",
  },
  certification: {
    title1: "Complete information",
    subTitle1: "Real name authentication",
    text1: "The applicant confirms the authenticity and validity of the documents provided by this real name authentication, and promises to comply with the user management regulations of Vancheen account store after completing the application for authentication.",
    text2: "The applicant confirms that the shop that has completed the real name certification shall not be transferred, sold or borrowed from the third party in any way without the consent of Vancheen, and all liabilities arising therefrom shall be borne by the applicant; In case of violation, Vancheen reserves the right to close the store account without any conditions.",
    menu1: "Corporate account real name authentication",
    menu2: "Real name authentication of self-employed accounts",
    vButton: "Go to verify",
    authFail: "The Reasons why the authentication fails",
    title2: "Input information",
    subTitle2: "Upload business license photo",
    text3: "All information on the photo should be clearly visible, true and effective, and no modification should be made",
    text4: "Photo support: jpg, jpeg, png, pdf format, size not more than 10m",
    sample: "Sample",
    upload: "Upload",
    label1: "Unified social credit code/registration number",
    label2: "The name on the business license",
    label3: "Operating period to",
    selectDate: "Please select a date",
    longTime: "Long-term",
    area: "Region",
    detailAddress: "Detail address",
    detailAddressText: "Please input your full address so that we can send you a written document if required",
    lPerson: "Legal person name",
    lPersonID: "Legal person ID card No.",
    IdNumber: "ID card No.",
    sampleFront: "Sample 1",
    sampleBack: "Sample 2",
    note: "Store holders shall pay taxes in accordance with local tax regulations, and account information cannot be modified after successful authentication.",
    bankTitle: "Corporate bank information",
    bankName: "Bank name",
    bankAccountName: "Bank account name",
    bankNote: "The name of the business license listed above shall not be modified",
    bankCardNumber: "Receive account",
    bankAddress: "Bank address",
    legalTitle: "Legal person bank information",
    rule1: "Please upload business license",
    rule2: "Please input the unified Social Credit code/registration number",
    rule3: "Please input the name on your business license",
    rule4: "Please select the operating period",
    rule5: "Please select your region",
    rule6: "Please input your full address",
    rule7: "Please input the legal person name",
    rule8: "Please upload the front of your legal person ID card",
    rule9: "Please upload the back of your legal person ID card",
    rule10: "Please input your ID number",
    rule11: "Please input your enterprise bank",
    rule12: "Please input your business bank account name",
    rule13: "Please input the enterprise bank account number",
    rule14: "Please input the enterprise bank address",
    rule15: "Please input legal person bank",
    rule16: "Please input legal person bank account name",
    rule17: "Please input legal person bank account number",
    rule18: "Please input legal person bank address",
    submitSuccess: "Submit success",
    submitFail: "Submit fail",
    type1: "Enterprise",
    type2: "Individual household"
  },
  productInfo: {
    orderDetail: "Order details",
    currentState: "Current order status",
    closeReason: "Order close reason",
    tab1: "Order information",
    tab2: "Logistics information",
    buyInfo: "Buyer information",
    receivingName: "Consignee",
    phoneNumber: "Contact number",
    receivingAddress: "Receive address",
    orderNumber: "Order number",
    payNumber: "Transaction number",
    createTime: "Create time",
    payTime: "Time of payment",
    noLogistics: "No logistics status",
    col1: "Product",
    col2: "Specification",
    col3: "State",
    col4: "Quantity",
    col5: "Unit price",
    col6: "Discounts",
    col7: "Funds received",
    category: "Classification",
    noState: "No state",
    express: "Express"
  },
  //C端
  cDefault: {
    title1: "Unpay",
    title2: "Undeliver",
    title3: "Unreceive",
    subTitle1: "User management",
    menu1: "Likes&Collects",
    menu2: "Follow shops",
    menu3: "Register shop",
    menu4: "Browsing Histories",
    menu5: "Delivery Address",
    subTitle2: "My Order",
    menu6: "Unpay",
    menu7: "Undeliver",
    menu8: "Unreceive",
    menu9: "Completed",
    subTitle3: "Others",
    menu10: "Service agreement",
    menu11: "Privacy policy",
    menu12: "Platform rules",
    menu13: "About us",
    menu14: "Coupon",
  },
  couponInterpret: {
    state1: "Unuse",
    state2: "Have been used",
    state3: "Unavailable",
    goUse: "Use",
    endDate: "Maturity time",
    noCondition: "No threshold",
    condition: "Use up to  {value}",
    maxCount: "Limit {value}",
    couponCount: "¥ {value} coupon",
    alertTitle: "You have received these coupon",
    col1: "Coupon",
    col2: "Condition",
    col3: "Maturity time",
    noCoupon: "No coupon",
    canuseTitle: "Available coupons",
    notuseTitle: "Not available coupons",
    reason: "The reason of this order is unavailable: It does not meet the usage conditions"
  },
  cOrder: {
    tab1: "All",
    tab2: "Unpay",
    tab3: "Undeliver",
    tab4: "Unreceive",
    tab5: "Completed",
    totalOrder: "{number} orders in total",
    toDetail: "Product details",
    col1: "Product info",
    col2: "Product name",
    col3: "Order number",
    col4: "Price",
    col5: "State",
    col6: "Create time",
    col7: "Operate",
    col8: "Specification",
    col9: "Quantity",
    col10: "Logistics",
    col11: "Total amount",
    freight: "Freight included",
    pay: "Pay",
    cancelOrder: "Cancel order",
    confirmOrder: "Confirm receipt",
    viewLogistics: "View logistics",
    payVoucher: "payment voucher",
    payMethod: "payment method",
    noPayment: "No payment options available",
    orderNumber: "Order number",
    logisticsState: "Logistics state",
    postNumber: "Post number",
    option1: "Credit card online payment",
    option2: "Offline payment",
    errorText: "This order is not paid offline",
    payDetail: "View / Pay",
    countDown: "The order will be automatically cancel if not pay ; The remaining time is",
    orderDetail: "Order details",
    closeReason: "Order close reason",
    currentState: "Current order status",
    orderTime: "Order time",
    payTime: "Time of payment",
    freightText: "Freight",
    totalText: "Total amount",
    textButton: "Current offline payment “{text}”, click to view",
    shopName: "Shop name"
  },
  goodsAttention: {
    col1: "Product image",
    col2: "Product name",
    col3: "Price",
    col4: "State",
    col5: "Operate",
    state1: "Off shelf",
    state2: "On sale",
    viewProduct: "View product",
    cancelFavorite: "Remove favorite"
  },
  shopAttention: {
    col1: "Store image",
    col2: "Store name",
    col3: "Operate",
    viewStore: "View store",
    cancelFollow: "Remove follow"
  },
  footmark: {
    col1: "Product image",
    col2: "Product name",
    col3: "Price",
    col4: "Browse date",
    col5: "Operate",
    viewProduct: "View product",
  },
  shipping: {
    create: "Create shipping address",
    name: "Name",
    phoneNumber: "Phone number",
    postalCode: "Postal code",
    address: "Address",
    operate: "Operate",
    edit: "Edit",
    delete: "Delete",
    editAddress: "Edit shipping address",
    receivingName: "Addressee's name",
    country: "Country",
    city: "City",
    addressDetail: "Address detail",
    isDefault: "Set it to the default address",
    submit: "Submit",
    yes: "Yes",
    no: "No",
    default: "Default address"
  },
  userManage: {
    title: "User Settings",
    subTitle1: "Change avatar",
    subTitle2: "User name",
    subTitle3: "Edit nickname",
    changeAvatar: "Change avatar",
    nickname: "Nickname",
    nickname1: "Original nickname",
    nickname2: "New nickname",
    updateName: "Update nickname",
    uploadLimit: "Upload file size cannot exceed 1MB!"
  },
  contactService: {
    title: "Problem list",
    createProblem: "Create problem",
    col1: "Problem title",
    col2: "Problem type",
    col3: "Submit time",
    col4: "State",
    col5: "Operate",
    view: "View",
    tips: "Tips",
    serviceContent: "Select the service you need",
    inputTitle: "Please input the problem title",
    inputContent: "Please input content",
    contact: "Your contact information",
    inputEmail: "Please provide your email address/phone number",
    submit: "Submit",
    option1: "Complaints and suggestions",
    option2: "Refund application",
    option3: "Others",
    inputAll: "Please input all before submitting",

    detailTitle: "Problem detail",
    row1: "Title",
    row2: "Content",
    row3: "Contact way",
    row4: "Create time",
    record: "Communication record",
    col6: "Date",
    col7: "Replier",
    col8: "Reply content",
    noRecord: "No record",
    addTo: "Add reply",
    dialogContent: "Please input your additional question",
  },
  authentication: {
    authFail: "Reasons why the authentication fails",
    info: "Information",
    upload: "Upload",
    text1: "Driver's license or passport picture (front and back)",
    text2: "All information on the photo should be clearly visible, true and effective, and no modification should be made;",
    text3: "Photo support: jpg, jpeg, png, pdf format, size not more than 10m",
    title: "Shop information",
    passPort: "Driver's license/passport number",
    name: "Name",
    bankName: "Bank name",
    bankNumber: "Bank account number",
    bankAddress: "Bank address",
    postAddress: "Post address",
    shopName: "Shop name",
    submit: "Submit",
    rule1: "Please upload driver's license or passport picture",
  },
  payment: {
    authFail: "The Reasons why the authentication fails",
    step1: "Ready to upload",
    step2: "Pending verification",
    step3: "Authentication fails",
    step4: "Authentication success",
    transfer1: "Please transfer to the bank account below and provide the screenshot of the bank transfer voucher",
    transfer2: "Please input the payment account information",
    accountName: "Account name",
    accountNumber: "Account number",
    bankAddress: "Bank address",
    postAddress: "Post address",
    bankName: "Bank name",
    uploadFile: "Upload file",
    uploadText: "Please upload a screenshot of the payment voucher to ensure that the content is clearly visible",
    name: "Name",
    bankNumber: "Bank card number",
    submit: "Submit",
    reSubmit: "Resubmit",
  }
};
